<template>
    <div>
    <el-breadcrumb separator="/" class="bread">

        <el-breadcrumb-item>素材管理</el-breadcrumb-item>
    </el-breadcrumb>
        <!-- 操作-->
<el-form>
    <el-form-item>
        <el-col :span="3">

            <el-button type="primary"  @click="handleAdd(-1)" v-if="btnAll.btn_0211">上传素材</el-button>
        </el-col>
        <el-col :span="3">
            <el-button type="primary"  @click="editeTagedialogVisible=true" v-if="btnAll.btn_0211">分组管理</el-button>
        </el-col>
    </el-form-item>

</el-form>
        <el-tabs v-model="activeName" @tab-click="handleTabPaneClick">
            <el-tab-pane label="图片" name="image">


        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding: 20px 0px;text-align: left">
            <el-form :inline="true" :model="topForm" ref="topForm">
                <el-form-item >
                    <el-input v-model="topForm.resourcesName" placeholder="素材名称" ></el-input>
                </el-form-item>
                <!--<el-form-item prop="resourcesTypeId">
                    <el-select v-model="topForm.resourcesTypeId" placeholder="请选择素材类型">
                        <el-option
                                v-for="item in materiaTypeList"
                                :label="item.resources_type_name"
                                :value="item.resources_type_id">
                        </el-option>
                    </el-select>
                </el-form-item>-->
                <!-- tag start ---------------------------------------------------->
                <el-form-item prop="tagId">
                    <el-select v-model="topForm.tagId" clearable  placeholder="分组" @change="getData()" >

                        <el-option :value="default_label_id"  :label="default_label_name"></el-option>
                        <el-option
                                v-for="item in taglist" :label="item.label_name" :value="item.label_id" >
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- tag  ent ---------------------------------------------------->
                <el-form-item>
                    <el-button type="primary" class="" @click="search" icon="search":loading="loading">查询</el-button>
                </el-form-item>


                <el-form-item >
                    <el-button type="primary" @click="resetForm('topForm')">重置</el-button>
                </el-form-item>

            </el-form>
        </el-col>
        <!-- 表格分页-->
        <div class="block">
            <el-table   :data="tableData"  ref="multipleTable"  border  style="width: 100%;" v-loading="loading2"
                      element-loading-text="拼命加载中"    >

                <el-table-column   width="255" label="图片" style="text-align: center" >
                <template scope="scope"> <!--<el-checkbox v-model="scope.row.checked">备选项</el-checkbox>-->
                    <img :src="scope.row.download_url"  style="width: 60%">
                </template>
                </el-table-column>
                <el-table-column prop="resources_name" label="名称" > </el-table-column>
                <el-table-column prop="feature" label="尺寸" > </el-table-column>
                <el-table-column prop="update_time" label="更新时间" sortable     width="160px">  </el-table-column>
                <el-table-column prop="author_name" label="操作用户">  </el-table-column>
              <el-table-column label="分组" >
                    <template scope="scope">
                        <el-tag
                                type="primary"
                                v-for="item   in scope.row.tag"
                                :close-transition="false"
                                @close="closeTagquote(item.id)"
                                style="margin: 3px 3px;">
                            {{item.name}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="230px">
                    <template scope="scope">
                        <el-button  size="small" @click="materiaEdit(scope.row)" >编辑</el-button>
                        <el-button  size="small"  type="danger"  @click="handleDelete(scope.row)" >删除</el-button>
                        <el-button  size="small"  type="danger"  @click="moveGroupClick(scope.row)" >分组</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>



        <div class="block">

            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-chahange="handleSizeChange"
                    :current-page="currentpage"
                    :page-count="pagesCount"
                    :page-sizes="pagesizes"
                    :page-size="pagesize"
                    :total="pagesCount"
                    layout=" total, prev, pager, next, jumper"
            >
            </el-pagination>

        </div>
            </el-tab-pane>
        </el-tabs>

        <!--弹窗分组移动 -->

        <el-dialog
                title="移动分组"
                :visible.sync="dialogVisible"
                :modal-append-to-body="false"
                width="70%" top="15%"
        >


            <el-form :model="tagForm" :rules="rules" ref="tagForm" label-width="100px" class="demo-ruleForm">
                <el-form-item  label="图片" ><img :src="tagForm.move_downloadUrl" style="width: 50%"></el-form-item>
                <el-form-item   label="当前分组">

                    <el-tag
                            type="primary"
                            style="margin: 3px 3px;">
                       {{tagForm.move_labelName}}
                    </el-tag>

                   <!-- <el-input v-model="tagForm.move_labelName"  :disabled="true"></el-input>-->
                </el-form-item>
                <el-form-item prop="move_labelId"  label="移动到">
                    <el-select v-model="tagForm.move_labelId"   placeholder="分组" >
                        <el-option  v-for="item in taglist" :disabled="item.label_id==''?true:false"  :label="item.label_name" :value="item.label_id" >


                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="move_labelId" >
                    <el-button  type="primary"   size="small" @click="moveGroupAjax('tagForm')" >确定</el-button>
                </el-form-item>

            </el-form>



        </el-dialog>
    <!-- 弹窗 新增/修改分组-->
        <el-dialog
                title="编辑分组"
                :visible.sync="editeTagedialogVisible"
                :modal-append-to-body="false"
                width="70%" top="15%"
        >

            <el-form :model="edittagForm" :rules="rules" ref="edittagForm" label-width="100px" class="demo-ruleForm">


                <el-form-item prop="labelId"  label="分组">
                    <el-select v-model="edittagForm.labelId"   placeholder="分组" >
                        <el-option  v-for="item in taglist" :label="item.label_name" :value="item.label_id" :disabled="item.is_delete==0 ||  item.label_id==''?true:false" >
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item    label="组名">
                    <el-input v-model="edittagForm.label_name">  </el-input>
                </el-form-item>
                <el-form-item  >
                    <el-button  type="primary"   size="small" @click="addLabel('edittagForm')" >新增</el-button>
                    <el-button  type="primary"   size="small" @click="editLabel('edittagForm')" >修改</el-button>
                    <el-button  type="primary"   size="small" @click="deleteLabel('edittagForm')" >删除</el-button>
                </el-form-item>

            </el-form>


        </el-dialog>
    </div>
</template>
<script>
    /*import  Bootpage from "../page/Bootpage.vue"*/
    import moment  from 'moment'
    import ElFormItem from "../../../../node_modules/element-ui/packages/form/src/form-item.vue";
    import ElInput from "../../../../node_modules/element-ui/packages/input/src/input.vue";
    import ElForm from "../../../../node_modules/element-ui/packages/form/src/form.vue";
    import ElCol from "element-ui/packages/col/src/col";
    export  default{
        components: {
            ElCol,
            ElForm,
            ElInput,
            ElFormItem},
        data(){

            return {
                default_label_name:"全部分组",
                default_label_id:"",
                activeName: 'image',
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 10,//行数
                activeNum: 0, //默认起始行数
                endNum: 10,//默认结束行数
                tableData: [], // 分页组件传回的分页后数据


                //参数设置
                url: this.admin_host+"/material/admin/find/list", // 分页查询请求路径
                topForm:{
                    resourcesName:'',
                    resourcesTypeId:'',
                    tagId: '',
                },
                checked:true,
                multipleSelection:[],
                materiaTypeList:[ ],
                loading:false,
                loading2:false,
                isTableSelectAll:false,
                initOrgInfo:{
                    level:'',
                    orgId:[]
                },
                /*弹窗选择*/
                /*弹窗内容选择*/
                btnAll:{
                    btn_0211:true,
                    btn_0212:true,
                    btn_0213:true,
                    btn_0214:true,
                    btn_0216:true,
                },
                //checkbox
                checkboxlength:0,
                //tag======================
                taglist: [],
                //tag end======================
                title:"",
                tenantId:"",
                labelTypeId:"material",
                //素材分组

                dialogVisible:false,
                tagForm:{
                    move_labelId:"",
                    move_resourcesId:"",
                    move_downloadUrl:"",
                    move_labelName:"",
                },
                edittagForm:{
                    label_name:"",
                    level:1,
                    parentId:0,
                    labelTypeId:"material",
                    author_id:this.getcookie("username_client"),
                    author_name:this.getcookie("username_client"),
                    tenant_id:this.getcookie("storeId"),
                    labelId:"",
                },
                editeTagedialogVisible:false,
                rules:{
                    move_labelId: [
                        { required: true, message: '请选择组', trigger: 'change' }
                    ],
                    add_labelName:[
                        { required: true, message: '输入组名', trigger: 'blue' }
                    ],
                    labelId:[
                        { required: true, message: '选择组', trigger: 'change' }
                    ],
                    label_name:[
                        { required: true, message: '输入组名', trigger: 'blue' }
                    ]
                }
            }


        },
        created(){
           var tenantId=this.getcookie("storeId");
           this.tenantId=tenantId;
            this.getResourcesTypeList();
            this.getLabelList();
            this.getData();
        },
        watch:{
            //'$route':['deviceState'] //监听路由参数变化
            '$route':function(){

                this.getRouterParams();
            }
        },
        methods: {
            search(){
              this.activeNum=0;
              this.getData();
            },
            getResourcesTypeList(){
                this.$http.get(this.admin_host+"/material/admin/type/find/list?tenantId="+this.tenantId).then(response =>{
                        if(response.status==200){
                            this.materiaTypeList=response.body.Data.resourcesTypeList;
                        }
                },function(response){
                    this.$message({ showClose: true, message: '网络异常', type: 'error'
                    });
                });

            },
            getLabelList(){
                this.$http.get(this.admin_host+"/label/admin/find/list?labelTypeId="+this.labelTypeId+"&tenantId="+this.tenantId).then(response =>{
                    if(response.status==200){
                      //  var str={"label_name":"全部分组","label_id":""}

                        var array=[];
                      //  array.push(str);
                        $.each(response.body.Data.labelList,function (i,item) {
                            array.push(item);
                        });

                        this.taglist=array;
                    }
                },function(response){
                    this.$message({ showClose: true, message: '网络异常', type: 'error'
                    });
                });
            },
            handleSizeChange(val){
              //  console.log(`每页 ${val} 条`);
                this.pagesize=val
                this.activeNum=(val*this.currentpage)-val;
                this.endNum=(val*this.currentpage)
                this.getData();
                //数目变更
            },
            handleCurrentChange(val){
                this.currentpage=val;
                this.activeNum=(this.pagesize*val)-this.pagesize
                this.endNum=(this.pagesize*val)
                this.getData();
            },
            getData(){
                //数据请求

                this.loading2 = true;

                //异步请求
                var _this=this;
                this.$http.get(this.url+"?iDisplayStart="+this.activeNum+"&iDisplayLength="+this.pagesize+"&resourcesName="+this.topForm.resourcesName+
                    "&resourcesTypeId="+this.topForm.resourcesTypeId+"&labelId="+this.topForm.tagId+"&tenantId="+this.tenantId+"")
                    .then(response => {
                        if (response.status === 200) {
                            this.pagesCount = response.body.Data.count;
                            this.tableData = response.body.Data.resourcesList

                            this.loading2 = false;
                        }
                    },function(response){
                        this.loading2 = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            formatterTime(row, column) {
                var d = new Date(row.update_time);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },

            handleDelete(row) {
                var params ={resources_id:row.resources_id} ;
                this.$confirm('你确定要删除这条数据么？删除是不可恢复的', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'

                }).then(() => {
                    this.$http.post(this.admin_host + "/material/admin/delete", params)
                        .then(response => {
                            this.$message({
                                showClose: true,
                                message: '删除成功',
                                type: 'success'
                            });
                            this.getData();
                        }, function (response) {
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'
                            });
                        });

                })
            },

            materiaEdit(row){
                this.$router.push( {name:"materialEdit",params:{resourcesId:row.resources_id}})
            },

            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.topForm.resourcesName='', this.topForm.resourcesTypeId=''
                this.topForm.tagId="";
                this.getData();
            },

            handleAdd(id){
                this.$router.push( {name:"materialAdd",params:{}})

            },

            /*=========================================================================分组*/
            addLabel(formName){
                console.log(this.$refs[formName]);
//                this.$refs[formName].validate((valid) => {
//                    if (valid) {
                        if(this. edittagForm.label_name==""){
                            this.$message({showClose: true, message: '组名不能为空', type: 'error'})
                            ;
                        }else {
                            var params={
                                level:this. edittagForm.level,
                                parentId:this. edittagForm.parentId,
                                labelTypeId:this. edittagForm.labelTypeId,
                                author_id:this. edittagForm.author_id,
                                author_name:this. edittagForm.author_name,
                                tenant_id:this. edittagForm.tenant_id,
                                label_name:this. edittagForm.label_name,
                                labelId:this. edittagForm.labelId,
                            }
                            var url=this.admin_host + "/label/admin/save";

                            this.$http.post(url, params)
                                .then(response => {
                                    if(response.body.Code=="200"){
                                        this.$message({ showClose: true, message: '操作成功',type: 'success' })

                                    }else{
                                        this.$message({showClose: true, message: response.body.Meta,type: 'error' });
                                    }
                                   // this.editeTagedialogVisible=false;
                                    this.getLabelList();
                                }, function (response) {
                                    this.$message({showClose: true, message: '网络异常',type: 'error' });
                                });
                        }


//                    }else{
//
//                    }
//                })



            },


            editLabel(formName){

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                if(this. edittagForm.label_name==""){
                    this.$message({showClose: true, message: '组名不能为空', type: 'error'});
                }else {


                    var params = {

                        level: this.edittagForm.level,
                        parentId: this.edittagForm.parentId,
                        labelTypeId: this.edittagForm.labelTypeId,
                        author_id: this.edittagForm.author_id,
                        author_name: this.edittagForm.author_name,
                        tenant_id: this.edittagForm.tenant_id,
                        label_name: this.edittagForm.label_name,
                        labelId: this.edittagForm.labelId,
                    }

                    var url = this.admin_host + "/label/admin/modify";


                    this.$http.post(url, params)
                        .then(response => {
                            if(response.body.Code=="200"){
                                this.$message({ showClose: true, message: '操作成功',type: 'success' })

                            }else{
                                this.$message({showClose: true, message: response.body.Meta,type: 'error' });
                            }
                          //  this.editeTagedialogVisible=false;
                            this.getLabelList();

                        }, function (response) {
                            this.$message({showClose: true, message: '网络异常', type: 'error'});
                        });
                }
                    }else{

                    }
                });
            },

            deleteLabel(formName) {

                var params ={labelId:this. edittagForm.labelId} ;
                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        this.$confirm('你确定要删除这条数据么？删除是不可恢复的', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$http.post(this.admin_host + "/label/admin/delete", params)
                                .then(response => {
                                    if(response.body.Code=="200"){
                                        this.$message({ showClose: true, message: '删除成功',type: 'success' })
                                        this.editeTagedialogVisible=false;
                                    }
                                    this.getLabelList();
                                    this.getData();
                                }, function (response) {
                                    this.$message({ showClose: true, message: '网络异常', type: 'error'
                                    });
                                });

                        })
                    }else {

                    }
                });

            },


            moveGroupClick(row){
                this.tagForm.move_resourcesId=row.resources_id;
                this.tagForm.move_downloadUrl=row.download_url;
                if(row.tag.length>0){
                    this.tagForm.move_labelName=row.tag[0].name;
                }

                this.dialogVisible=true;
                console.log(this.taglist);
            },

            //移动分组
            moveGroupAjax(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // alert('submit!');
                        var params={labelId:this.tagForm.move_labelId,relevanId:this.tagForm.move_resourcesId}
                        this.$http.post(this.admin_host + "/label/admin/relevan/moveGroup", params)
                            .then(response => {

                                this.$message({ showClose: true, message: '移动成功',type: 'success' })
                                //关闭弹窗

                                //刷新
                                this.getData();
                                this.dialogVisible=false;
                            }, function (response) {
                                this.$message({showClose: true, message: '网络异常',type: 'error' });
                            });

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });


            },
            /**--------------------------------------权限控制 stop--------------------------------------------------------**/
            updateBtnState(pid){
                var _this=this
                this.$store.dispatch("getButton",pid).then((res)=>{
                    var data=res.btnlist;
                    var btnAlllist=new Array("btn_0211","btn_0212","btn_0213","btn_0214","btn_0216");
                    var btnAlllist1=btnAlllist;
                    if(data.length>0) {
                        for (var i = 0; i < data.length; i++) {
                            var btnId="btn_"+data[i].resourceId;
                            for(var j=0;j<btnAlllist.length;j++){
                                if(btnAlllist[j]==btnId){
                                    btnAlllist1.splice(j,1)
                                }
                            };
                        }
                    }
                //隐藏按钮
                for(var h=0;h<btnAlllist1.length;h++){
                    if(btnAlllist1[h]=="btn_0211"){
                        _this.btnAll.btn_0211=false;
                    }
                    if(btnAlllist1[h]=="btn_0212"){
                        _this.btnAll.btn_0212=false;
                    }
                    if(btnAlllist1[h]=="btn_0213"){
                        _this.btnAll.btn_0213=false;
                    }
                    if(btnAlllist1[h]=="btn_0214"){
                        _this.btnAll.btn_0214=false;
                    }
                    if(btnAlllist1[h]=="btn_0216"){
                        _this.btnAll.btn_0216=false;
                    }
                }
                })
            },
            handleTabPaneClick:function (tab, event) {

                console.log(tab, event);
            }
            /**--------------------------------------end--------------------------------------------------------**/

        }

    }

</script>


// WEBPACK FOOTER //
// MaterialManager.vue?4e0d2006